import { NextRouter } from 'next/router';

/**
 * If we're in a `/landers/preview/` route. These routes are indended to be
 * displayed within an iframe and may handle content differently.
 */
export function isPreviewRouteView(pathOrRouter: string | NextRouter) {
  const path = typeof pathOrRouter === 'string' ? pathOrRouter : pathOrRouter.asPath;

  // Trailing '/' is required so we don't accidentally match dynamic landers
  // slugs, e.g. `/landers/preview-foo/...`
  if (path.startsWith('/landers/preview/')) {
    return true;
  }

  // Asset library preview routes get all of their content from the parent
  // window. We should consider this a preview route if we have an exact match
  // or if we're in a sub-route.
  const assetLibraryRoute = '/preview-asset';
  if (path.split(/[?#]/)[0] === assetLibraryRoute || path.startsWith(`${assetLibraryRoute}/`)) {
    return true;
  }

  return false;
}
